/* WN-HOME — motion de los capítulos del homepage.
   1. Parallax sutil: elementos [data-wn-parallax="factor"] dentro de
      .wn-parallax-wrap (la imagen viaja más lento que el scroll).
   2. Carrusel de testimonios: flechas prev/next sobre scroll-snap nativo.
   3. Gestos del Hero (wheel + touch): ver initHeroGestures() más abajo —
      dos bugs reales de Chrome con .wn-hero (overflow-x:auto nativo,
      sections/wn-hero.liquid) capturando/tragando el scroll vertical de la
      página, resueltos a mano sin tocar el overflow nativo.
   El reveal por capítulo NO vive aquí: usa el scroll-trigger de Dawn
   (assets/animations.js), que ya respeta prefers-reduced-motion. */
(function () {
  'use strict';

  /* ── Parallax ── */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var wraps = document.querySelectorAll('.wn-parallax-wrap[data-wn-parallax]');
    if (!wraps.length) return;

    var items = [];
    Array.prototype.forEach.call(wraps, function (wrap) {
      var factor = parseFloat(wrap.getAttribute('data-wn-parallax')) || 0.35;
      Array.prototype.forEach.call(wrap.querySelectorAll('.wn-parallax'), function (el) {
        items.push({ el: el, wrap: wrap, factor: factor });
      });
    });
    if (!items.length) return;

    var ticking = false;

    function update() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (item) {
        /* dentro de secciones pineadas el transform lo controla wn-scrub.js */
        if (item.wrap.closest('.wn-scrub-active')) return;
        /* medir el wrapper, no el elemento transformado (evita feedback) */
        var rect = item.wrap.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var distance = rect.top + rect.height / 2 - vh / 2;
        /* la imagen es 134% de alto (wn-base.css): ±17% de margen real */
        var maxShift = (item.el.offsetHeight - rect.height) / 2;
        var shift = Math.max(-maxShift, Math.min(maxShift, distance * item.factor));
        item.el.style.transform = 'translate3d(0, ' + shift.toFixed(1) + 'px, 0)';
      });
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  }

  /* ── Carrusel de testimonios (delegado: sobrevive re-renders del editor) ──
     Target absoluto (offsetLeft de la tarjeta) en vez de scrollBy relativo:
     con scroll-snap-type mandatory, un scrollBy({behavior:'smooth'}) no
     resuelve el snap y el track se queda pegado en el punto de partida. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.wn-carousel__btn') : null;
    if (!btn) return;
    /* los botones prev/next viven en .wn-*__nav, hermano de .wn-carousel
       (no ancestro) — closest('.wn-carousel') nunca los encuentra. Se
       busca en la section entera, que sí envuelve a ambos. */
    var section = btn.closest('section');
    var track = section && section.querySelector('.wn-carousel__track');
    if (!track) return;
    var cards = track.querySelectorAll('.wn-carousel__card');
    if (!cards.length) return;
    var dir = btn.classList.contains('wn-carousel__btn--prev') ? -1 : 1;
    var current = track.scrollLeft;
    var target = dir > 0 ? track.scrollWidth : 0;
    if (dir > 0) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].offsetLeft > current + 4) { target = cards[i].offsetLeft; break; }
      }
    } else {
      for (var j = cards.length - 1; j >= 0; j--) {
        if (cards[j].offsetLeft < current - 4) { target = cards[j].offsetLeft; break; }
      }
    }
    track.scrollTo({ left: target, behavior: 'smooth' });
  });

  /* ── Gestos del Hero (wheel desktop + touch mobile) ──
     .wn-hero sigue siendo overflow-x:auto nativo (sections/wn-hero.liquid) —
     necesario porque SlideshowComponent (assets/global.js) maneja flechas/
     dots/autoplay con this.slider.scrollTo() y los sincroniza escuchando el
     evento 'scroll' nativo; con overflow-x:hidden ese evento deja de
     dispararse en Chrome y scrollTo() pasa a ser un no-op silencioso —
     probado en QA con overflow:hidden real: las flechas dejaban de mover el
     carrusel del todo. Por eso el fix va acá, con overflow nativo intacto.

     Con overflow-x:auto quedan dos gestos por resolver a mano (los dos
     confirmados en QA disparando eventos reales, no por deducción):
     - Horizontal: se decide el eje del gesto y, si es horizontal, se
       previene el default nativo y se arrastra/asienta el slide a mano
       (igual que antes). Sigue haciendo falta porque touch-action:pan-y
       desactiva el paneo horizontal nativo por touch a propósito (ver CSS),
       y porque wheel no tiene ningún equivalente a touch-action.
     - Vertical: un wheel vertical sobre un elemento que SÍ puede scrollear
       en horizontal queda "tragado" por Chrome en vez de encadenarse a la
       página (bug real, no sólo el "redirige a horizontal" que se podría
       esperar) — se reenvía a mano con window.scrollBy(0, deltaY) y se
       previene el default roto. En touch no hace falta el mismo reenvío:
       touch-action:pan-y ya le dice al compositor desde el arranque del
       gesto que el paneo vertical es nativo acá, sin ambigüedad que
       resolver en JS.

     nextBtn/prevBtn sólo se usan como chequeo de que el markup trae controles
     (blocks.size > 1, sections/wn-hero.liquid) — la navegación por swipe no
     los clickea (ver nota en endDrag), pero mover scrollLeft dispara igual el
     'scroll' listener de SliderComponent/SlideshowComponent (assets/global.js)
     que mantiene sincronizados los dots y el estado disabled de las flechas. */
  function initHeroGestures() {
    if (window.Shopify && window.Shopify.designMode) return;

    var wraps = document.querySelectorAll('.wn-hero-slideshow');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var slider = wrap.querySelector('.wn-hero');
      var slides = wrap.querySelectorAll('.wn-hero__slide');
      var nextBtn = wrap.querySelector('.wn-hero__arrow--next');
      var prevBtn = wrap.querySelector('.wn-hero__arrow--prev');
      if (!slider || slides.length < 2 || !nextBtn || !prevBtn) return;

      var SWIPE_THRESHOLD = 40; /* px mínimos de arrastre para contar como swipe intencional */
      var AXIS_LOCK = 10; /* px de movimiento antes de decidir el eje del gesto (touch) */

      var slideW = slides[0].clientWidth;
      window.addEventListener(
        'resize',
        function () {
          slideW = slides[0].clientWidth;
        },
        { passive: true }
      );

      var dragging = false;
      var dragStartScrollLeft = 0;
      var dragDx = 0; /* negativo = arrastre hacia la izquierda → slide siguiente */

      function clampScrollLeft(value) {
        var max = slider.scrollWidth - slider.clientWidth;
        return Math.max(0, Math.min(max, value));
      }

      function beginDrag() {
        dragging = true;
        dragStartScrollLeft = slider.scrollLeft;
        dragDx = 0;
      }

      /* dx: desplazamiento acumulado desde que arrancó el gesto, tal que
         scrollLeft = dragStartScrollLeft - dx (dx negativo = contenido se
         mueve a la izquierda = scrollLeft sube = slide siguiente). */
      function updateDrag(dx) {
        dragDx = dx;
        slider.scrollLeft = clampScrollLeft(dragStartScrollLeft - dx);
      }

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        if (!slideW || Math.abs(dragDx) < SWIPE_THRESHOLD) {
          /* gesto corto/indeciso: vuelve a asentarse en el slide de partida,
             instantáneo (scrollLeft directo, no scrollTo smooth) — mismo
             comportamiento que ya tienen las flechas y los dots
             (SlideshowComponent.setSlidePosition en assets/global.js
             tampoco pide 'smooth'). */
          slider.scrollLeft = dragStartScrollLeft;
          return;
        }
        /* Nota: a propósito NO se reusa nextBtn/prevBtn.click() acá —
           SlideshowComponent.onButtonClick (assets/global.js) calcula el
           destino como "scrollLeft actual + un slide completo", y con el
           drag ya en curso scrollLeft nunca queda alineado a un slide, así
           que overshootearía. Se calcula el índice directo desde el slide
           de partida (dragStartScrollLeft) en vez de desde el scrollLeft ya
           arrastrado, con el mismo wraparound simple primero↔último. */
        var startIndex = Math.round(dragStartScrollLeft / slideW);
        var targetIndex = startIndex + (dragDx < 0 ? 1 : -1);
        if (targetIndex < 0) targetIndex = slides.length - 1;
        if (targetIndex > slides.length - 1) targetIndex = 0;
        slider.scrollLeft = targetIndex * slideW;
      }

      /* ── Desktop: wheel/trackpad ──
         passive:false porque necesita poder frenar el default nativo en los
         dos casos (horizontal Y vertical, ver nota arriba) y reemplazarlo por
         el manejo a mano. */
      var wheelEndTimer = null;
      slider.addEventListener(
        'wheel',
        function (event) {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
            /* vertical: Chrome no lo encadena solo a la página cuando pasa
               por acá (ver nota arriba) — se reenvía a mano. */
            event.preventDefault();
            window.scrollBy(0, event.deltaY);
            return;
          }
          event.preventDefault();
          if (!dragging) beginDrag();
          updateDrag(dragDx - event.deltaX);
          clearTimeout(wheelEndTimer);
          wheelEndTimer = setTimeout(endDrag, 180);
        },
        { passive: false }
      );

      /* ── Mobile: touch ──
         El touchmove con passive:false sólo vive mientras dura el gesto (se
         agrega en touchstart, se saca en touchend/touchcancel) — así el
         listener no-pasivo no queda pegado permanentemente sobre el Hero. */
      var touchAxis = null;
      var touchStartX = 0;
      var touchStartY = 0;
      var onTouchMove = null;

      slider.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length > 1) return; /* no interferir con pinch/zoom */
          var touch = event.touches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchAxis = null;
          beginDrag();

          onTouchMove = function (moveEvent) {
            var t = moveEvent.touches[0];
            var dx = t.clientX - touchStartX;
            var dy = t.clientY - touchStartY;

            if (touchAxis === null) {
              /* recién en el primer movimiento significativo se decide el eje
                 — y queda fijo el resto del gesto, no se re-evalúa a mitad de
                 camino. */
              if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
              touchAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            }
            if (touchAxis !== 'x') return; /* vertical: se deja pasar intacto a la página */

            moveEvent.preventDefault();
            updateDrag(dx);
          };
          slider.addEventListener('touchmove', onTouchMove, { passive: false });
        },
        { passive: true }
      );

      function endTouch() {
        if (onTouchMove) {
          slider.removeEventListener('touchmove', onTouchMove);
          onTouchMove = null;
        }
        if (touchAxis === 'x') {
          endDrag();
        } else {
          dragging = false; /* gesto vertical: nunca se tocó scrollLeft, nada que asentar */
        }
        touchAxis = null;
      }

      slider.addEventListener('touchend', endTouch, { passive: true });
      slider.addEventListener('touchcancel', endTouch, { passive: true });
    });
  }

  initParallax();
  initHeroGestures();
}());
